(function ($, document, window) {
	'use strict';

	$(function () {
		$(document).ready(function () {
			const $trigger = $('.js-site-search-trigger');
			const $body = $('.js-search-body');
			const $input = $('[type="search"]', $body);
			const $close = $('.js-search-close');
			const activeClass = 'site-search--is-active';
			const timeout = 250; // wait for css animation to finish
	
			$trigger.on('click', function ( e ) {
				console.log('click')
				e.preventDefault();
	
				$body.toggleClass(activeClass);
	
				if ($body.hasClass(activeClass)) {
					setTimeout(function () {
						$input.trigger('focus');
					}, timeout);
				}
			});
	
			$close.on('click', function () {
				$body.removeClass(activeClass);
			});
		})
	});
})(jQuery);
